import { gql } from '@apollo/client'

export const PIN_IS_AVAILABLE = gql`
  query PinIsAvailable($pinNumber: String!, $userId: ID) {
    pinIsAvailable(pinNumber: $pinNumber, userId: $userId)
  }
`
